module.exports = __webpack_public_path__ + "assets/img/23.06fad828.png";